import React, { useEffect, useState } from 'react';
import CompanyLayout from '../../components/Company/CompanyLayout';
import Card from '../../components/UI/Card';
import Button from '../../components/UI/Button';
import * as companyJobService from '../../services/companyJobService';
import * as companyResumeService from '../../services/companyResumeService';
import { toast } from 'react-toastify';

export default function MatchCandidates() {
	const [jobs, setJobs] = useState([]);
	const [selectedJob, setSelectedJob] = useState('');
	const [config, setConfig] = useState({ minScore: 60, skillsWeight: 50, experienceWeight: 30, educationWeight: 20, locationRequired: false });
	const [matching, setMatching] = useState(false);
	const [results, setResults] = useState([]);

	useEffect(() => {
		(async () => {
			try {
				const res = await companyJobService.getCompanyJobs({ isActive: true, page: 1, limit: 100 });
				setJobs(res.jobs || []);
			} catch {
			}
		})();
	}, []);

	async function handleMatchCandidates() {
		if (!selectedJob) {
			toast.error('Please select a job');
		 return;
		}
		setMatching(true);
		try {
			const res = await companyResumeService.matchCandidates(selectedJob);
			const list = (res.candidates || res || []).filter((c) => (c.score || 0) >= config.minScore);
			setResults(list);
			toast.success(`Matched ${list.length} candidates`);
		} catch {
			toast.error('Matching failed');
		} finally {
			setMatching(false);
		}
	}

	return (
		<CompanyLayout>
			<div className="space-y-6">
				<header className="flex items-center justify-between">
					<h1 className="text-2xl font-bold">Match Candidates to Job</h1>
				</header>
				<div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
					<Card title="Select Job">
						<select className="w-full border rounded px-3 py-2" value={selectedJob} onChange={(e) => setSelectedJob(e.target.value)}>
							<option value="">Select job</option>
							{jobs.map((j) => (
								<option key={j._id} value={j._id}>
									{j.title}
								</option>
							))}
						</select>
					</Card>
					<Card title="Configure Matching">
						<div className="space-y-2 text-sm">
							<label className="flex items-center justify-between">
								<span>Minimum Match %</span>
								<input type="number" className="border rounded px-2 py-1 w-20" value={config.minScore} onChange={(e) => setConfig((c) => ({ ...c, minScore: Number(e.target.value) || 0 }))} />
							</label>
							<label className="flex items-center justify-between">
								<span>Skills Weight</span>
								<input type="number" className="border rounded px-2 py-1 w-20" value={config.skillsWeight} onChange={(e) => setConfig((c) => ({ ...c, skillsWeight: Number(e.target.value) || 0 }))} />
							</label>
							<label className="flex items-center justify-between">
								<span>Experience Weight</span>
								<input type="number" className="border rounded px-2 py-1 w-20" value={config.experienceWeight} onChange={(e) => setConfig((c) => ({ ...c, experienceWeight: Number(e.target.value) || 0 }))} />
							</label>
							<label className="flex items-center justify-between">
								<span>Education Weight</span>
								<input type="number" className="border rounded px-2 py-1 w-20" value={config.educationWeight} onChange={(e) => setConfig((c) => ({ ...c, educationWeight: Number(e.target.value) || 0 }))} />
							</label>
							<label className="flex items-center gap-2">
								<input type="checkbox" checked={config.locationRequired} onChange={(e) => setConfig((c) => ({ ...c, locationRequired: e.target.checked }))} />
								Location match required
							</label>
						</div>
						<div className="mt-3">
							<Button onClick={handleMatchCandidates} loading={matching}>
								Run Matching
							</Button>
						</div>
					</Card>
					<Card title="Results Summary">
						<p className="text-sm text-gray-600">Matched: {results.length}</p>
						<p className="text-sm text-gray-600">Average Score: {results.length ? Math.round(results.reduce((a, b) => a + (b.score || 0), 0) / results.length) : 0}%</p>
					</Card>
				</div>

				<Card title="Candidates">
					{matching ? (
						<p className="text-sm text-gray-500">Matching...</p>
					) : !results.length ? (
						<p className="text-sm text-gray-500">No results.</p>
					) : (
						<div className="overflow-x-auto">
							<table className="min-w-full text-sm">
								<thead className="bg-gray-50">
									<tr>
										<th className="text-left px-4 py-2">#</th>
										<th className="text-left px-4 py-2">Name</th>
										<th className="text-left px-4 py-2">Score</th>
										<th className="text-left px-4 py-2">Actions</th>
									</tr>
								</thead>
								<tbody>
									{results.map((r, idx) => (
										<tr key={r._id || idx} className="border-t">
											<td className="px-4 py-2">{idx + 1}</td>
											<td className="px-4 py-2">{r.sections?.personalInfo?.name || 'Candidate'}</td>
											<td className="px-4 py-2">{r.score || 0}%</td>
											<td className="px-4 py-2">
												<Button variant="ghost">View Profile</Button>
												<Button variant="ghost">Shortlist</Button>
											</td>
										</tr>
									))}
								</tbody>
							</table>
						</div>
					)}
				</Card>
			</div>
		</CompanyLayout>
	);
}


